import { ControlType, Property, PropertyType } from "../../../base/types";
import { FC, useEffect } from "react";

import { AvatarText } from "../avatar/AvatarText";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";
import { useLazyGetMediaQuery } from "../../../services/data/media";

export const MediaComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const mediaId: string | undefined = properties[Property.MediaId];
    const altText: string | undefined = properties[Property.AltText];
    const tooltip: string | undefined = properties[Property.Tooltip];

    if (!mediaId || mediaId === '00000000-0000-0000-0000-000000000000') {
        return <AvatarText className={className} label="" random={true} title={tooltip} />
    }

    return (
        <MediaImage mediaId={mediaId} altText={altText} className={className} title={tooltip} />
    )
}

export const MediaImage = ({ mediaId, altText, title, className }: {
    mediaId: string,
    altText?: string,
    title?: string,
    className?: string,
}) => {
    const [getMedia, { data: media, isSuccess }] = useLazyGetMediaQuery();

    useEffect(() => {
        if (!mediaId || mediaId === '00000000-0000-0000-0000-000000000000') return
        getMedia(mediaId)

        // eslint-disable-next-line
    }, [mediaId])

    return <>
        {!isSuccess && <div className={className}>{altText}</div>}
        {isSuccess && media && <img alt={altText}
            className={className}
            title={title}
            src={`data:${media?.mimeType};base64,${media?.base64}`} />}
    </>
}

Registry.addControl({
    id: "cbf31e83-3dba-405d-8ad0-9e76bf398a6c",
    name: "Media",
    type: ControlType.Media,
    properties: [
        { id: Property.MediaId, name: 'Media Id', type: PropertyType.String },
        { id: Property.AltText, name: 'Alternate Text', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: MediaComponent
})
